import { combineReducers } from 'redux';
import cariReducer from './cariReducer';

//combine multiple reducers
export default combineReducers({
    cariReducer,
    //... add more reducer files here
});